import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Po } from './po';
import { Branch } from '../../accounting/branch';
import { PoOrder } from './po-orders';
import { Configuration } from '../../../app.constants';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { PoBranch } from './poBranch';
import { Piece } from '../../inventory/piece';
import { Supplier } from '../suppliers/supplier';

@Injectable()
export class PoService {
    _poBranchTransferUrl = this._configuration.apiUrl + '/v2/branchtransfer';
    _poBranchTransferUrlItems = this._configuration.apiUrl + '/v2/branchtransfer/items';
    _poUrl = this._configuration.apiUrl + '/v2/purchaseorder';
    _poItemsUrl = this._configuration.apiUrl + '/v2/purchaseorder/items';
    _colorUrl = this._configuration.apiUrl + '/v2/color';

    constructor(private _http: Http,
        private _configuration: Configuration,
        public _authService: AuthenticationService) { }

    getAllPos(): Observable<Po[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('list', 'true');

        return this._http.get(this._poUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['purchaseorders'] == null || !Array.isArray(body['purchaseorders']))
                    return [];
                return body['purchaseorders'];
            }
        );
    }

    getOnePo(id: string): Observable<Po> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.get(this._poUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                let final: Po;

                if (body['purchaseorders'] == null || !Array.isArray(body['purchaseorders'])) {
                    final = new Po();
                } else {
                    final = body['purchaseorders'][0];
                }

                final.actual_arrival_date = final.actual_arrival_date ? final.actual_arrival_date.substring(0, 10) : '';
                final.order_date = final.order_date ? final.order_date.substring(0, 10) : '';
                final.estimated_arrival_date = final.estimated_arrival_date ? final.estimated_arrival_date.substring(0, 10) : '';
                final.proforma_invoice_date = final.proforma_invoice_date ? final.proforma_invoice_date.substring(0, 10) : '';
                final.downpayment_date = final.downpayment_date ? final.downpayment_date.substring(0, 10) : '';
                final.final_invoice_date = final.final_invoice_date ? final.final_invoice_date.substring(0, 10) : '';
                final.payment_date = final.payment_date ? final.payment_date.substring(0, 10) : '';
                final.closing_date = final.closing_date ? final.closing_date.substring(0, 10) : '';
                final.sailing_date = final.sailing_date ? final.sailing_date.substring(0, 10) : '';

                return final;
            }
        );
    }

    getPoItems(po_id: string): Observable<PoOrder[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('po_id', po_id);

        return this._http.get(this._poItemsUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['items'] == null || !Array.isArray(body['items']))
                    return [];
                return body['items'];
            }
        );
    }

    getOnePoBranch(id: string): Observable<PoBranch> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.get(this._poBranchTransferUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                let final: PoBranch;

                if (body['branchtransfers'] == null || !Array.isArray(body['branchtransfers'])) {
                    final = new PoBranch()
                } else {
                    final = body['branchtransfers'][0];
                }

                final.order_date = final.order_date ? final.order_date.substring(0, 10) : '';
                final.estimated_arrival_date = final.estimated_arrival_date ? final.estimated_arrival_date.substring(0, 10) : '';
                return final;
            }
        );
    }

    getBranchPoByNumber(number: string): Observable<PoBranch> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('po_number', number);

        return this._http.get(this._poBranchTransferUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                let final: PoBranch;

                if (body['branchtransfers'] == null || !Array.isArray(body['branchtransfers'])) {
                    final = new PoBranch()
                } else {
                    final = body['branchtransfers'][0];
                }

                final.order_date = final.order_date ? final.order_date.substring(0, 10) : '';
                final.estimated_arrival_date = final.estimated_arrival_date ? final.estimated_arrival_date.substring(0, 10) : '';
                return final;
            }
        );
    }


    getBranchPoItems(po_id: string): Observable<Piece[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('po_id', po_id);

        return this._http.get(this._poBranchTransferUrlItems, { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['items'] == null || !Array.isArray(body['items']))
                    return [];
                return body['items'];
            }
        );
    }

    getBranchPoNotPreparedItems(po_id: string): Observable<Piece[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('po_id', po_id);

        return this._http.get(this._poBranchTransferUrl + '/itemsnotprepared', { headers: h, search: s }).map(
            response => {
                let body = response.json();
                if (body['items'] == null || !Array.isArray(body['items']))
                    return [];
                return body['items'];
            }
        );
    }

    setBranchPoNotPreparedItems(po_id: string, items: any[]): Observable<Piece[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('po_id', po_id);

        return this._http.post(this._poBranchTransferUrl + '/itemsnotprepared', items, { headers: h, search: s }).map(response => response.json());
    }

    createBranchPo(po: PoBranch) {
        let h: Headers = this._authService.getHeaders();

        return this._http.post(this._poBranchTransferUrl, po, { headers: h, search: null }).map(response => response.json());
    }

    getStatuses(): Observable<string[]> {
        return Observable.of(['DRAFT', 'ORDERED', 'CANCELLED']);
    }

    getTransportWays(): Observable<string[]> {
        return Observable.of(['AIR', 'LCL', 'FCL', 'LAND']);
    }

    getDesignColors(design_id): Observable<string[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('minify', 'true');
        s.append('id', design_id);

        console.log('chestii');

        return this._http.get(this._colorUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();

                console.log(body);

                if (body['colors'] == null || !Array.isArray(body['colors']))
                    return ['muie'];
                return ['numuie'];
            }
        );
    }

    getSupplierColors(supplier_id): Observable<string[]> {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('minify', 'true');
        s.append('supplier_id', supplier_id);

        return this._http.get(this._colorUrl, { headers: h, search: s }).map(
            response => {
                let body = response.json();

                console.log("aiciedracu");
                console.log(body);

                if (body['colors'] == null || !Array.isArray(body['colors']))
                    return [];
                return body['colors'];
            }
        );
    }

    createPo(po: Po) {
        let h: Headers = this._authService.getHeaders();

        return this._http.post(this._poUrl, po, { headers: h, search: null }).map(response => response.json());
    }

    deletePo(id: string) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.delete(this._poUrl, { headers: h, search: s }).map(response => Object.assign({ id: id }, response.json()));
    }

    deleteBranchPo(id: string) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.delete(this._poBranchTransferUrl, { headers: h, search: s }).map(response => Object.assign({ id: id }, response.json()));
    }

    updatePo(id: string, po: Po) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.put(this._poUrl, po, { headers: h, search: s }).map(response => response.json());
    }

    updateBranchPo(id: string, po: PoBranch) {
        let h: Headers = this._authService.getHeaders();
        let s: URLSearchParams = new URLSearchParams();

        s.append('id', id);

        return this._http.put(this._poBranchTransferUrl, po, { headers: h, search: s }).map(response => response.json());
    }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/purchasing/pos/po.service.ts